import { Injectable } from "@angular/core";
import { Amplify } from '@aws-amplify/core';
import { environment } from '../../shared/services/util.service';


@Injectable({ providedIn: "root" })

export class AmplifyConfigService {
  configureAmplify(config) {
    Amplify.configure({
      API: {
        GraphQL: {
          endpoint: config.graphqlEndpoint,
          region: config.graphqlRegion,
          defaultAuthMode: config.defaultAuthMode,
        }
      }
    });
  }
}
